module.exports = __webpack_public_path__ + "static/media/doctor-search_p4_2.e22760c0.png";